import { entityStatuses } from './entityStatusConfig';

export const supplierStatuses = entityStatuses;

export const supplierFormInitialValues = {
  companyName: '',
  contactNumber: '',
  sacksMark: '',
  address: '',
  photoUrl: '',
  status: 'Active',
};
